import internalStateService from "./InternalStateService";
import initialTranslations from "../translations/";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

let translations = initialTranslations;

//if language is not set, will translate to current language (as in globalProperties)
function translate(name, language) {
    //extract current language
    if (!language) {
        language = internalStateService.getGlobalProperty("locale");
    }

    if (!translations[language]) {
        WEBUILogs.error("Missing translations for language: " + language);
        return getDefaultTranslation(name);
    }

    if (!translations[language][name]) {
        WEBUILogs.error("Missing " + language + " translation for: " + name);
        return getDefaultTranslation(name);
    }

    return translations[language][name];
}

//On missing translation use default language
//Extranet usecase
function getDefaultTranslation(name) {
    let defaultLanguage = internalStateService.getGlobalProperty("defaultLocale");
    WEBUILogs.warn("Using " + defaultLanguage + " translation for: " + name);
    return translations[defaultLanguage][name];
}

function addTranslations(language = "en-GB", newTranslations) {
    translations[language] = translations[language] || {};

    Object.assign(translations[language], newTranslations);
}

function getDataTypeMessage(dataType) {
    if (!dataType) {
        return;
    }

    return translate(dataType + "Message");
}

export default {
    translate,
    addTranslations,
    getDataTypeMessage
};
